




















import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { useUserInvestmentFeeAcknowledgementStore } from "@/employee/store/userInvestmentFeeAcknowledgement";
import { useThemeStore } from "@/shared/store/theme";
import { useUserStore } from "@/shared/store/user";

@Component
export default class UserInvestmentChoiceFeeAcknowledgementModal extends Vue {
  userInvestmentFeeAcknowledgementStore = useUserInvestmentFeeAcknowledgementStore();
  themeStore = useThemeStore();
  userStore = useUserStore();

  mounted (): void {
    this.userInvestmentFeeAcknowledgementStore.getSignedAcknowledgements();
  }

  get showModal () {
    return this.userInvestmentFeeAcknowledgementStore.displayChoiceFeeModal;
  }

  onAccept (): void {
    this.userInvestmentFeeAcknowledgementStore.postChoiceFeeSignedAcknowledgement();
  }
}
